import uniq from 'lodash/uniq';

import type { ProChoiceSource } from '@wecasa/common/src/types/commons';
import type { ProChoice } from '@wecasa/common/src/types/customer';
import { formatStringListWithSeparator } from '@wecasa/common/src/utils/formatting';
import { areExclusive, isWanted } from '@wecasa/common/src/utils/previous-pros';

import { translate } from '@wecasa/i18n';

const t = translate('basket.previous_pros');

export const getBasketTitle = (wantedChoices: ProChoice[]) => {
  if (areExclusive(wantedChoices)) {
    return wantedChoices.length === 1
      ? t('.title.only.single', { pro: wantedChoices[0].pro.first_name })
      : t('.title.only.multiple', { count: wantedChoices.length });
  }

  return t('.title.if_possible', { count: wantedChoices.length });
};

export const getBasketText = (wantedChoices: ProChoice[]) => {
  if (wantedChoices.length === 0) return '';

  if (areExclusive(wantedChoices)) {
    return wantedChoices.length === 1
      ? t('.text.only.single', { pro: wantedChoices[0].pro.first_name })
      : t('.text.only.multiple', {
          proNames: formatStringListWithSeparator(
            wantedChoices.map(({ pro }) => pro.first_name),
            { separator: 'or' },
          ),
        });
  }

  return t('.text.if_possible', {
    proNames: formatStringListWithSeparator(
      wantedChoices.map(({ pro }) => pro.first_name),
      { separator: 'or' },
    ),
  });
};

export const getSourcesFormatted = (sources: ProChoiceSource[]) => uniq(sources).sort().join(', ');

export const getWantedProChoicesSources = (proChoices: ProChoice[]): ProChoiceSource[] =>
  proChoices.filter(isWanted).map(({ source }) => source);
